<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon pending">
              <i class="el-icon-time"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.pendingAppointments }}</div>
              <div class="stat-label">待审核预约</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon approved">
              <i class="el-icon-check"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.totalAppointments }}</div>
              <div class="stat-label">总预约数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon broker">
              <i class="el-icon-user"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.pendingBrokers }}</div>
              <div class="stat-label">待审批经纪人</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon driver">
              <i class="el-icon-truck"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stats.totalDrivers }}</div>
              <div class="stat-label">注册司机数</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">最近预约记录</span>
            <el-button type="text" @click="$router.push('/appointment-audit')">查看全部 <i class="el-icon-arrow-right"></i></el-button>
          </div>
          <el-table 
            :data="recentAppointments" 
            stripe 
            size="small"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
          >
            <el-table-column prop="driverName" label="司机姓名" width="90" align="center"></el-table-column>
            <el-table-column prop="plateNumber" label="车牌号" width="90" align="center">
              <template slot-scope="scope">
                <el-tag type="info" size="mini">{{ scope.row.plateNumber }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="grainType" label="粮食品种" width="90" align="center"></el-table-column>
            <el-table-column prop="date" label="预约日期" width="110" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)" size="mini" effect="light">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">经纪人注册申请</span>
            <el-button type="text" @click="$router.push('/broker-audit')">查看全部 <i class="el-icon-arrow-right"></i></el-button>
          </div>
          <el-table 
            :data="recentBrokers" 
            stripe 
            size="small"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
          >
            <el-table-column prop="name" label="姓名" width="100" align="center">
              <template slot-scope="scope">
                <el-avatar size="mini" style="vertical-align: middle; margin-right: 5px; background: #67C23A;">
                  {{ scope.row.name ? scope.row.name.charAt(0) : '用' }}
                </el-avatar>
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="120" align="center"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" width="160" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 'pending' ? 'warning' : 'success'" size="mini" effect="light">
                  {{ scope.row.status === 'pending' ? '待审批' : '已通过' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        pendingAppointments: 0,
        totalAppointments: 0,
        pendingBrokers: 0,
        totalDrivers: 0
      },
      recentAppointments: [],
      recentBrokers: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const [statsRes, appointRes, brokerRes] = await Promise.all([
          this.$http.get('/admin/dashboard/stats'),
          this.$http.get('/admin/appointment/list?status=pending&pageSize=5'),
          this.$http.get('/admin/broker/list?status=pending&pageSize=5')
        ])
        
        if (statsRes.data.code === 200) {
          this.stats = statsRes.data.data
        }
        if (appointRes.data.code === 200) {
          this.recentAppointments = appointRes.data.data.records || []
        }
        if (brokerRes.data.code === 200) {
          this.recentBrokers = brokerRes.data.data.records || []
        }
      } catch (e) {
        this.stats = {
          pendingAppointments: 3,
          totalAppointments: 156,
          pendingBrokers: 2,
          totalDrivers: 48
        }
        this.recentAppointments = [
          { driverName: '张师傅', plateNumber: '粤K12345', grainType: '小麦', date: '2026-04-10', status: 'pending' },
          { driverName: '李师傅', plateNumber: '粤K54321', grainType: '玉米', date: '2026-04-10', status: 'approved' },
          { driverName: '王师傅', plateNumber: '粤K67890', grainType: '稻谷', date: '2026-04-11', status: 'pending' }
        ]
        this.recentBrokers = [
          { name: '陈经纪', phone: '13800138003', createTime: '2026-04-09 10:30:00', status: 'pending' },
          { name: '刘经纪', phone: '13800138004', createTime: '2026-04-08 15:20:00', status: 'pending' }
        ]
      }
    },
    getStatusType(status) {
      const map = { pending: 'warning', approved: 'success', rejected: 'danger', withdrawn: 'info' }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = { pending: '待审核', approved: '已通过', rejected: '已拒绝', withdrawn: '已撤回' }
      return map[status] || status
    }
  }
}
</script>

<style scoped>
.dashboard {
  .stat-card {
    .stat-content {
      display: flex;
      align-items: center;
      gap: 15px;
    }
    .stat-icon {
      width: 60px;
      height: 60px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      
      &.pending { background: linear-gradient(135deg, #f6d365 0%, #fda085 100%); }
      &.approved { background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%); }
      &.broker { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
      &.driver { background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); }
    }
    .stat-info {
      .stat-value {
        font-size: 32px;
        font-weight: 600;
        color: #303133;
        line-height: 1;
      }
      .stat-label {
        color: #909399;
        font-size: 14px;
        margin-top: 8px;
      }
    }
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .card-header .card-title {
    font-size: 15px;
    font-weight: 500;
    color: #303133;
  }
}
</style>
